(function(){
  function selectedOptionLabel(){
    var checked=document.querySelector('variant-picker input[type=radio]:checked, .variant-picker input[type=radio]:checked, fieldset input[type=radio]:checked, form[action*="/cart/add"] input[type=radio]:checked, input[type=radio]:checked');
    if(!checked) return null;
    var lab=document.querySelector('label[for="'+checked.id+'"]');
    var t=((lab&&lab.textContent)||checked.value||'').replace(/\s+/g,' ').trim();
    return t||null;
  }
  function allCheckedLabels(){
    var out=[];
    var boxes=document.querySelectorAll('variant-picker, .variant-picker, form[action*="/cart/add"]');
    var root=boxes[0]||document;
    var checked=root.querySelectorAll('input[type=radio]:checked');
    checked.forEach(function(el){
      var lab=document.querySelector('label[for="'+el.id+'"]');
      var t=((lab&&lab.textContent)||el.value||'').replace(/\s+/g,' ').trim();
      if(t) out.push(t);
    });
    return out;
  }
  function matchesLabel(alt, label){
    alt = alt || '';
    if(!label) return true;
    if(alt.indexOf(label) !== -1) return true;
    // Soft match pack forms: "5 Pack" vs "5-pack"
    var norm=function(s){return (s||'').toLowerCase().replace(/\s+/g,' ').replace(/-/g,' ').trim();};
    return norm(alt).indexOf(norm(label)) !== -1;
  }
  function apply(){
    var labels=allCheckedLabels();
    var color=labels[0] || selectedOptionLabel();
    if(!color) return;
    var gallery=document.querySelector('product-gallery');
    if(!gallery) return;
    var mediaItems=[].slice.call(gallery.querySelectorAll('.product-gallery__media[data-media-id]'));
    var thumbs=[].slice.call(gallery.querySelectorAll('.product-gallery__thumbnail[data-media-id], button.product-gallery__thumbnail, [data-media-id].product-gallery__thumbnail'));
    if(!thumbs.length){
      thumbs=[].slice.call(gallery.querySelectorAll('.product-gallery__thumbnail-list [data-media-id], scroll-shadow [data-media-id]'));
    }
    var anyTagged=mediaItems.some(function(el){
      var img=el.querySelector('img');
      var alt=img ? (img.getAttribute('alt')||'') : '';
      return /Amazon gallery/i.test(alt);
    });
    if(!anyTagged) return;

    // Prefer matching the most specific selected label that appears in any alt
    var matchLabel=color;
    for(var i=0;i<labels.length;i++){
      var hit=mediaItems.some(function(el){
        var img=el.querySelector('img');
        return matchesLabel(img ? img.getAttribute('alt') : '', labels[i]);
      });
      if(hit){ matchLabel=labels[i]; break; }
    }

    var firstMedia=null;
    mediaItems.forEach(function(el){
      var img=el.querySelector('img');
      var alt=img ? (img.getAttribute('alt')||'') : '';
      var match=matchesLabel(alt, matchLabel);
      el.hidden = !match;
      el.style.display = match ? '' : 'none';
      if(match && !firstMedia) firstMedia=el;
    });
    thumbs.forEach(function(el){
      var id=el.getAttribute('data-media-id');
      var media=id && gallery.querySelector('.product-gallery__media[data-media-id="'+id+'"]');
      var alt='';
      if(media){
        var img=media.querySelector('img');
        alt=img ? (img.getAttribute('alt')||'') : '';
      } else {
        var timg=el.querySelector('img');
        alt=timg ? (timg.getAttribute('alt')||'') : (el.getAttribute('aria-label')||'');
      }
      var match=matchesLabel(alt, matchLabel);
      el.hidden = !match;
      el.style.display = match ? '' : 'none';
    });

    if(firstMedia){
      try {
        var carousel = gallery.querySelector('media-carousel');
        if(carousel && typeof carousel.select === 'function'){
          carousel.select(firstMedia.getAttribute('data-media-id'));
        } else if(carousel){
          firstMedia.scrollIntoView({inline:'center', block:'nearest', behavior:'instant'});
        } else {
          firstMedia.scrollIntoView({inline:'center', block:'nearest'});
        }
        var thumb=gallery.querySelector('[data-media-id="'+firstMedia.getAttribute('data-media-id')+'"].product-gallery__thumbnail, .product-gallery__thumbnail-list [data-media-id="'+firstMedia.getAttribute('data-media-id')+'"]');
        if(thumb){ try{ thumb.click(); }catch(e){} }
      } catch(e) {}
    }
  }
  function boot(){
    apply();
    document.addEventListener('change', function(e){
      if(e.target && e.target.matches && e.target.matches('input[type=radio]')) apply();
    });
    document.addEventListener('variant:change', apply);
    document.addEventListener('product:variant-change', apply);
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
